var React = require('react');

function Long (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M54.8644 64.7109L64.8423 57.4976C64.8423 57.4976 38.3423 52.2461 35.1932 34.5201C30.6986 9.21939 11.5608 0.937728 11.5608 0.937728L0.986695 8.50003C0.986695 8.50003 13.8806 17.1827 21.3926 41.009C29.2211 65.8384 54.8644 64.7109 54.8644 64.7109Z","fill":"#FFC01F"}));
}

Long.defaultProps = {"width":"65","height":"65","viewBox":"0 0 65 65","fill":"none"};

module.exports = Long;

Long.default = Long;
